"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightUnitSchema = void 0;
const zod_1 = require("zod");
exports.WeightUnitSchema = zod_1.z.enum(['kg', 'g', 'lbs']);
exports.default = exports.WeightUnitSchema;
//# sourceMappingURL=WeightUnitSchema.js.map